module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart"
  }, [_c('div', {
    staticClass: "poster-area"
  }, [_c('AnimePoster', {
    staticClass: "poster",
    attrs: {
      "data": _vm.data
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "scroll-area"
  }, [_c('h2', [_vm._v(_vm._s(_vm.data.title))]), _vm._v(" "), _c('div', {
    staticClass: "meta"
  }, [_vm._v("\n      " + _vm._s(_vm.data.episodes) + " " + _vm._s(_vm.data.episodes === 1 ? _vm.lang.interface.episode : _vm.lang.interface.episodes)), _c('br'), _vm._v("\n      ★ " + _vm._s(_vm.data.score.toFixed(2)) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "studio"
  }, [_vm._v(_vm._s(_vm.data.studio))]), _vm._v(" "), _c('div', {
    staticClass: "genre"
  }, [_vm._v(_vm._s(_vm.data.genre))]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.data.description))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-adbed55c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AnimeChart.vue
// module id = 70
// module chunks = 4